import React from "react";
import styles from "./progress-ui.module.scss";

// The worm level as a small hexagon with the number in it. Its colour moves up
// every ten levels, so a long-time player's badge looks it.
const BANDS = ["#28c4d4", "#55d16a", "#ffd23f", "#ff8a1d", "#c56bff", "#ff3d92"];
export function levelColor(level: number): string {
  return BANDS[Math.min(BANDS.length - 1, Math.floor(Math.max(0, level - 1) / 10))];
}

export default function LevelBadge({ level, size = 30, className }: { level: number; size?: number; className?: string }) {
  return (
    <span className={`${styles.badge} ${className || ""}`} style={{ "--lc": levelColor(level), width: size, height: size, fontSize: size * (level >= 100 ? 0.34 : 0.42) } as React.CSSProperties} aria-label={`Level ${level}`}>
      <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 1.5l9.1 5.25v10.5L12 22.5l-9.1-5.25V6.75z" /></svg>
      <b>{level}</b>
    </span>
  );
}

// The level as a ring that fills toward the next level, the number inside.
let ringIds = 0;
export function LevelRing({ level, into, need, size = 104, stroke = 8, label = true }: { level: number; into: number; need: number; size?: number; stroke?: number; label?: boolean }) {
  const [id] = React.useState(() => "lr" + ++ringIds);
  const r = (size - stroke) / 2, c = 2 * Math.PI * r;
  const pct = Math.max(0, Math.min(1, into / Math.max(1, need)));
  return (
    <span className={styles.ring} style={{ width: size, height: size }} aria-label={`Level ${level}, ${into} of ${need} XP`}>
      <svg width={size} height={size} aria-hidden="true">
        <defs><linearGradient id={id} x1="0" y1="0" x2="1" y2="1"><stop offset="0" stopColor="#28c4d4" /><stop offset="1" stopColor="#55d16a" /></linearGradient></defs>
        <circle cx={size / 2} cy={size / 2} r={r} stroke="rgba(255,255,255,0.1)" strokeWidth={stroke} fill="none" />
        {pct > 0 && <circle cx={size / 2} cy={size / 2} r={r} stroke={`url(#${id})`} strokeWidth={stroke} fill="none" strokeDasharray={`${c * pct} ${c}`} transform={`rotate(-90 ${size / 2} ${size / 2})`} />}
      </svg>
      <span className={styles.ringIn}><b style={{ fontSize: size * 0.36 }}>{level}</b>{label && <small style={{ fontSize: Math.max(8, size * 0.09) }}>LEVEL</small>}</span>
    </span>
  );
}
